
<ng-scrollbar [style.height]="customStyle" visibility="hover" [dir]="direction" appearance="compact">
  <ng-content />
</ng-scrollbar>
